import 'select2/dist/js/select2.full.js';

import 'simplebar';

import 'bootstrap';

import 'application/config';

import 'application/routes';

import 'application/run';

import 'application/values/values';

import 'application/directives/directives';

import 'application/filters/filters';

import 'application/services/services';

import 'application/factories/factories';

import 'angular-i18n/angular-locale_pt-br';

import 'daterangepicker';

import 'screw-filereader';

// Código global.

$(document)
	.on('shown.bs.modal', '.modal', function() {
		$(this)
			.find('[autofocus]:first')
			.trigger('focus');
	})

	.on('click', '[data-toggle="popover"]', function() {
		$(this).popover('show');
	})

	.on('click', () => $('.ui-select').removeClass('open'));

$(window).on('scroll', function() {
	let documentElement = document.documentElement,
		viewportHeight = Math.max(
			documentElement.clientHeight,
			window.innerHeight || 0
		),
		limit = documentElement.scrollHeight - 400;

	if (Math.round(documentElement.scrollTop) + viewportHeight >= limit) {
		$('[ng-scrollmax]:visible').each(function() {
			$(this).triggerHandler('scrollmax');
		});
	}
});
